import {
  APP_INITIALIZER,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { AuxiliaresModule } from './auxiliares/auxiliares.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoginService } from './modulos/login/login.service';
import { RecargaErrorHandler } from './auxiliares/recarga-error.handler';

// Locale
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';
import { getEspPaginatorIntl } from './auxiliares/paginator-intl';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PwaService } from './auxiliares/pwa.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './auxiliares/loading.interceptor';
import { EnvironmentService } from './environment';
import { MarcaService } from './auxiliares/marca.service';
import { MarkdownModule } from 'ngx-markdown';
registerLocaleData(localeEs, 'es-AR');
//

export function loadEnv(envService: EnvironmentService): () => Promise<void> {
  return () => envService.loadEnvironment();
}

// La marca (nombre, logos) sale del host, no del usuario: se carga antes del
// login. Los colores y fuentes de la marca entran por CSS desde index.html.
export function cargarMarca(marca: MarcaService): () => Promise<void> {
  return () => marca.cargar();
}

// Corre antes de que el router resuelva la primera navegación. Así un deep link
// abierto en una pestaña nueva sin sesión compartida llega a destino si el
// usuario tenía "Recordarme" activo, en vez de rebotar por el login.
export function restaurarSesion(
  loginService: LoginService,
): () => Promise<void> {
  return () => loginService.restaurarSesionAlArrancar();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    AuxiliaresModule,
    MarkdownModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    {
      provide: APP_INITIALIZER,
      useFactory: loadEnv,
      deps: [EnvironmentService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: cargarMarca,
      deps: [MarcaService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: restaurarSesion,
      deps: [LoginService],
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MatPaginatorIntl, useValue: getEspPaginatorIntl() },
    { provide: ErrorHandler, useClass: RecargaErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    public pwaService: PwaService,
    private envService: EnvironmentService,
  ) {
    console.log(`App version: ${this.envService.APP_VERSION}`);
  }
}
